import { WhitePage } from "./util";

export const Privacy = () => (
  <WhitePage>
    <div>
      <h2 className="text-3xl font-bold inline-block">Bodematlas</h2>
      <span className="pl-4 mb-10 text-gray-500">Privacy Policy</span>
    </div>
    <div className="max-w-3xl pt-4">
      <p className="mb-4">
        BodemAtlas B.V. verwerkt persoonsgegevens in de rol van verwerkingsverantwoordelijke (zoals
        bedoeld in de AVG).
      </p>
      <h3 className="text-xl font-bold mb-4 mt-8">Wij plaatsen de volgende Cookies</h3>
      <ul className="list-disc list-outside ml-6 mb-4 space-y-2">
        <li>
          cookies voor extra functionaliteit - deze cookies worden geplaatst om extra
          functionaliteit in te schakelen, zoals Google Maps (+ Streetview), YouTube, ShareThis
          (delen van pagina&quot;s via Social Media) en Twitter-feeds.
        </li>
        <li>
          cookies voor analytische doeleinden / verbeteren toekomstige gebruikerservaring - met
          behulp van Google Analytics houden wij anonieme gebruikersstatistieken bij. Hierin kunnen
          wij zien welke pagina&quot;s populair zijn en welke pagina&quot;s juist dienen te worden
          verbeterd. Zo kunnen wij de gebruikerservaring op de langere termijn kunnen verbeteren.
        </li>
        <li>
          cookies voor kernfuncties - hieronder valt o.a. de sessie-cookie, die ervoor zorgt dat de
          beveiliging en contactformulieren goed werken.
        </li>
      </ul>
      <h3 className="text-xl font-bold mb-4 mt-8">Wij verwerken de volgende persoonsgegevens</h3>
      <ul className="list-disc list-outside ml-6 mb-4 space-y-2">
        <li>
          technische gegevens, zoals uw IP-adres, het apparaat waarmee u onze website bezoekt en de
          pagina&quot;s die u bekijkt (geanonimiseerd)
        </li>
        <li>
          basisinformatie en contactgegevens zoals&nbsp;naam, de organisatie waar u werkt,
          e-mailadres en telefoonnummer (op het contactformulier)
        </li>
        <li>persoonsgegevens&nbsp;die u ons verstrekt wanneer u bij ons solliciteert</li>
      </ul>
      <h3 className="text-xl font-bold mb-4 mt-8">Waarom wij deze persoonsgegevens verwerken</h3>
      <ul className="list-disc list-outside ml-6 mb-4 space-y-2">
        <li>
          om u van dienst te kunnen zijn bij het indienen van een contactaanvraag, offerteaanvraag,
          een aanmelding/inschrijving of een andere aanvraag/actie
        </li>
        <li>voor analyse en verbetering van onze website</li>
        <li>om uw sollicitatie te kunnen beoordelen en op te kunnen volgen</li>
      </ul>
      <h3 className="text-xl font-bold mb-4 mt-8">Gegevensverwerking en deling</h3>
      <p className="mb-4">
        Deze persoonsgegevens worden verwerkt voor de uitvoering van commerciële doeleinden binnen
        de eigen organisatie, een overeenkomst, vanwege een wettelijke verplichting, met uw
        toestemming en/of vanwege een gerechtvaardigd belang.
      </p>
      <p className="mb-4">Wij delen uw gegevens niet met derde partijen.</p>
      {/*<p className="mb-4">Een deel van deze gegevens delen wij met de volgende derde partijen:</p>*/}
      {/*<ul className="list-disc list-outside ml-6 mb-4 space-y-2">*/}
      {/*  <li>Google - volledig geanonimiseerde gegevens voor meten bezoekgedrag en website statistieken</li>*/}
      {/*</ul>*/}
      <h3 className="text-xl font-bold mb-4 mt-8">Bewaartermijn</h3>
      <p className="mb-4">
        Uw gegevens worden - wanneer deze niet meer worden gebruikt en er geen belang meer bestaat
        in het bewaren van deze gegevens -&nbsp;in de website voor max. 24 maanden opgeslagen
      </p>
      <h3 className="text-xl font-bold mb-4 mt-8">Beveiliging</h3>
      <p className="mb-4">
        Alle persoonsgegevens die door deze website worden verwerkt en opgeslagen zijn zorgvuldig
        beveiligd met passende technische en organisatorische maatregelen. Voor (geanonimiseerde)
        gegevens die door Google Analytics verwerkt worden hebben wij een bewerkersovereenkomst
        afgesloten en deze worden exclusief via een versleutelde verbinding (SSL) met Google
        gedeeld. U kunt bij vragen hierover contact opnemen met ons.
      </p>
      <h3 className="text-xl font-bold mb-4 mt-8">Uw rechten</h3>
      <p className="mb-4">
        U heeft te allen tijde het recht om de persoonsgegevens die wij van u verwerken in te zien,
        door ons te laten wijzigen of zelfs te laten verwijderen wanneer de gegevens niet langer
        juist zijn of verwerking hiervan niet langer is gerechtvaardigd; dit ter onzer beoordeling.
        Daarnaast heeft u altijd het recht om een klacht in te dienen bij de toezichthouder
        Autoriteit Persoonsgegevens.
      </p>
    </div>
  </WhitePage>
);
